import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './themeInit.js';
import { Providers } from './components/Providers';
import WebApp from './WebApp';
import { startWebRuntime } from './web/webRuntime';
import { initInstallPrompt } from './web/installPrompt';
import './index.css';

startWebRuntime();
// Capture beforeinstallprompt before React mounts — Chrome fires it early.
initInstallPrompt();

// Offline app shell (production only — the dev server doesn't emit sw.js, and
// a stale shell cache during development would be maddening).
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js');
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Providers>
      <WebApp />
    </Providers>
  </StrictMode>
);
